// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Utils$OrcaPaymentPage from "./Utils.bs.js";

var braintreeApplePayUrl = "https://js.braintreegateway.com/web/3.92.1/js/apple-pay.min.js";

var braintreeClientUrl = "https://js.braintreegateway.com/web/3.92.1/js/client.min.js";

function loadBraintreeApplePayScripts(logger) {
  Utils$OrcaPaymentPage.loadScriptIfNotExist(braintreeClientUrl, logger, "BRAINTREE_CLIENT_SCRIPT");
  Utils$OrcaPaymentPage.loadScriptIfNotExist(braintreeApplePayUrl, logger, "APPLE_PAY_BRAINTREE_SCRIPT");
}

export {
  braintreeApplePayUrl ,
  braintreeClientUrl ,
  loadBraintreeApplePayScripts ,
}
/* Utils-OrcaPaymentPage Not a pure module */
